import React from 'react';
import { CollapseAllIcon, FolderIcon, PlusIcon } from '../../../icons';
import FolderRow from './FolderRow';

const FoldersSection = ({
  ready,
  folders,
  rootFolders,
  creatingFolder,
  creatingUnderParentId,
  newFolderName,
  onNewFolderNameChange,
  newFolderInputRef,
  onStartCreateFolder,
  onCreateDoc,
  onCollapseAll,
  canCollapseAll = false,
  onCommitNewFolder,
  onNewFolderKeyDown,
  docsByFolder,
  collapsedFolders,
  onToggleFolderExpand,
  selectedDocId,
  onSelectDoc,
  onOpenInNewTab,
  onDeleteDoc,
  organization,
  dropTargetId,
  dropHint,
  draggedFolderId,
  onDragOverTarget,
  onDropOnFolder,
  onDragLeaveTarget,
  onFolderDragStart,
  onFolderDragEnd,
  createDoc,
}) => (
  <div className="sidebar__docs-folders">
    <div className="sidebar__campaign-tools">
      <button
        type="button"
        className="sidebar__campaign-new"
        onClick={(e) => onStartCreateFolder(e, null)}
        disabled={!ready}
        title={ready ? 'New folder' : 'Loading organization…'}
      >
        <PlusIcon size={10} />
        <span>New folder</span>
      </button>
      <button
        type="button"
        className="sidebar__campaign-new"
        onClick={onCreateDoc}
        title="New doc"
      >
        <PlusIcon size={10} />
        <span>New doc</span>
      </button>
      <button
        type="button"
        className="sidebar__icon-btn sidebar__icon-btn--small"
        onClick={onCollapseAll}
        disabled={!canCollapseAll}
        title="Collapse all folders"
      >
        <CollapseAllIcon size={10} />
      </button>
    </div>

    {creatingFolder && creatingUnderParentId == null && (
      <div className="sidebar__docs-new-folder">
        <FolderIcon size={16} />
        <input
          ref={newFolderInputRef}
          type="text"
          className="sidebar__item-input"
          value={newFolderName}
          placeholder="Folder name"
          onChange={(e) => onNewFolderNameChange(e.target.value)}
          onBlur={onCommitNewFolder}
          onKeyDown={onNewFolderKeyDown}
          onKeyUp={(e) => e.stopPropagation()}
        />
      </div>
    )}

    {rootFolders.map((folder) => (
      <FolderRow
        key={folder.id}
        folder={folder}
        depth={0}
        docsByFolder={docsByFolder}
        allFolders={folders}
        collapsedFolders={collapsedFolders}
        onToggleExpand={onToggleFolderExpand}
        selectedDocId={selectedDocId}
        onSelectDoc={onSelectDoc}
        onOpenInNewTab={onOpenInNewTab}
        onDeleteDoc={onDeleteDoc}
        organization={organization}
        dropTargetId={dropTargetId}
        dropHint={dropHint}
        draggedFolderId={draggedFolderId}
        onDragOverTarget={onDragOverTarget}
        onDropOnTarget={onDropOnFolder}
        onDragLeaveTarget={onDragLeaveTarget}
        onFolderDragStart={onFolderDragStart}
        onFolderDragEnd={onFolderDragEnd}
        onStartCreateChild={onStartCreateFolder}
        creatingUnderParentId={creatingUnderParentId}
        creatingFolder={creatingFolder}
        newFolderName={newFolderName}
        onNewFolderNameChange={onNewFolderNameChange}
        newFolderInputRef={newFolderInputRef}
        onCommitNewFolder={onCommitNewFolder}
        onNewFolderKeyDown={onNewFolderKeyDown}
        createDoc={createDoc}
      />
    ))}
  </div>
);

export default FoldersSection;
